/**
 * 链配置与默认链（无选择时默认波场）
 */
export const BSC_CHAIN_ID = '0x38';
export const TRON_CHAIN_ID = '0x2b6653dc';

export const getSelectedChain = () => {
  return localStorage.getItem('selected_chain') || TRON_CHAIN_ID;
};
